import { ListProvider } from "./list-provider";
import { Contact } from "../../../../business-objects/contact/contact.model";
import { ContactStoreFacade } from "../../../../business-objects/contact/contact.store-facade";

export class ContactListAllProvider extends ListProvider<Contact> {

    getFacade(): ContactStoreFacade {
        return this.appFacade.objects.contact.store;
    }

    getPrimaryField(item: Contact): string {
        return item && item.name;
    }

    getSecondaryField(item: Contact): string {
        return item && item.email;
    }
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/form/list-providers/contact-list-all-provider.ts